<template lang="pug">
    .linkbox
        font-awesome-icon(class="icon" :icon="icon")
        h3 {{ link.hyperlink.name  }}
        h4 {{ link.sub_title }}
</template>

<script>

import _ from 'lodash'

export default {
    name: 'Iconbox',
    props: {
        icon: {
            type: String,
            required: true,
        },
        link: {
            type: Object,
            required: true,
        },
    }
}
</script>

<style lang="sass" scoped>
    @import "~bulma/sass/utilities/mixins"
    @import '~@/assets/sass/variables'
    .linkbox
        min-height: 120px
        background-color: #ebf6cb
        padding: 15px
        border-radius: 15px
        text-align: center
        color: #636363
        transition: transform .3s ease, box-shadow .3s ease, background-color .3s ease
        .icon
            font-size: 150%
            margin: 10px
            width: 50px
            height: 50px
        &:hover
            box-shadow: $box-shadow-3
            transform: scale(1.05)
        // background-color: #80bb3d
        // color: #fff
    h3
        font-size: 20px
        color: #636363 !important


</style>
